import {
  require_jquery
} from "./chunk-W467FMWY.js";
import {
  __toESM
} from "./chunk-AC2VUBZ6.js";

// ../../shared/node_modules/@pludoni/frontend-pack/src/plugins/jquery.js
var import_jquery = __toESM(require_jquery());
if (!("jQuery" in window)) {
  window.jQuery = import_jquery.default;
  window.$ = import_jquery.default;
}
var jquery_default = import_jquery.default;
export {
  jquery_default as default
};
//# sourceMappingURL=@pludoni_frontend-pack_src_plugins_jquery.js.map
